import { FunctionComponent, ReactElement, useState } from "react";
import { ContainerIconStack, ContainerStack, TitleAndSubtitles } from "./styled";

interface StackComponentProps {
  icon: ReactElement
  title: string
  valueActual: string
  total: string
}

const StackComponent: FunctionComponent<StackComponentProps> = ({ icon, valueActual, title, total }) => {
  // const [isOpen, setIsOpen] = useState<boolean>(true);

  // const onClose = () => setIsOpen(false);
  // const onOpen = () => setIsOpen(true)

  return (<>
    <ContainerStack>
      <TitleAndSubtitles>
        <h4 style={{
          fontSize: '18px',
          color: 'rgb(17 24 39)'
        }}>
          {title}
        </h4>
        {/* <h3>
          {valueActual}
        </h3> */}
        <p style={{
          fontSize: '16px',
          color: 'rgb(17 24 39)'
        }}>
          {total}
        </p>
      </TitleAndSubtitles>

      <ContainerIconStack>
        {/* {
          isOpen ? <div style={{ position: 'absolute', cursor: 'pointer', userSelect: 'none', top: -4, right: -4, padding: '4px', width: 25, height: 25, boxShadow: '2px 2px 2px rgba(0,0,0,.2)', alignItems: 'center', justifyContent: 'center', display: 'flex', borderRadius: '8px', background: '#fff', }} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>

          </div> :
            <div style={{ position: 'absolute', cursor: 'pointer', userSelect: 'none', top: -4, right: -4, padding: '4px', width: 25, height: 25, boxShadow: '2px 2px 2px rgba(0,0,0,.2)', alignItems: 'center', justifyContent: 'center', display: 'flex', borderRadius: '8px', background: '#fff', }} onClick={onOpen}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
            </svg>
            </div>
        } */}
        {icon}
      </ContainerIconStack>
    </ContainerStack>
  </>);
}

export default StackComponent;
